/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { textTransform } from 'utils';

export const BonusInfoWrapper = styled.div.attrs({
  className: 'bonus-info'
})`
  width: 100%;
  max-width: 1238px;
  margin: 0 auto;
  padding: 0 16px;

  .bonus-info__title {
    display: inline-block;
    vertical-align: middle;
    font-size: 2.4rem;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: ${textTransform};
    color: ${({ theme }) => theme.color.textPrimary};
    margin: 24px 0 16px 0;
  }

  .container {
    padding: 0;
    overflow: hidden;
  }

  .heading-1 {
    margin-bottom: 8px;
    text-transform: ${textTransform};
  }

  .heading-1,
  .heading-2 {
    font-weight: 700;
    font-size: 16px;
  }

  .heading-2 {
    letter-spacing: 0.2px;
  }

  .s-information {
    padding: 16px 0 28px;
  }

  .s-information__image-top {
    width: 100%;
  }

  br + br {
    display: none;
  }

  .b-additional-info {
    margin-top: 15px;
    font-size: 14px;
    color: #888;
  }

  .l-regular {
    padding-left: 18px;
    list-style-type: disc;
  }

  .l-regular__item + .l-regular__item {
    margin-top: 7px;
  }

  .l-regular__item {
    list-style: disc;
    display: list-item;
  }

  .l-rewards {
    list-style: none;
  }

  .l-rewards._inner {
    margin: 5px 0 0 -18px;
  }

  .l-rewards__item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 11px 8px;
    border-radius: 8px;
    box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.6);
    background-color: #242424;
    color: #fff;
    overflow: hidden;
  }

  .l-rewards__item + .l-rewards__item {
    margin-top: 8px;
  }

  .l-rewards__item-img {
    width: 48px;
    margin-right: 10px;
  }

  .l-rewards__item-title {
    flex-grow: 1;
    padding: 0 10px 0 0;
    font-weight: 500;
    line-height: 1.3;
    letter-spacing: 1px;
    text-transform: ${textTransform};
  }

  .l-rewards__item-price {
    flex-shrink: 0;
    font-weight: 700;
  }

  .s-info {
    padding: 16px 0 28px;
  }

  .list li {
    width: 100%;
  }

  .list li + li {
    margin-top: 8px;
  }

  .marked-li {
    display: flex;
    align-items: flex-start;
  }

  .marked-li:before {
    content: '';
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    padding: 5px;
    margin-right: 8px;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 78.369 78.369'%3E%3Cpath fill='%23de1619' d='M78.049 19.015L29.458 67.606a1.094 1.094 0 0 1-1.548 0L.32 40.015a1.094 1.094 0 0 1 0-1.547l6.704-6.704a1.095 1.095 0 0 1 1.548 0l20.113 20.112 41.113-41.113a1.095 1.095 0 0 1 1.548 0l6.703 6.704a1.094 1.094 0 0 1 0 1.548z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-origin: content-box;
  }

  /* >>> Accordion menu */
  .l-faq {
    margin: 0 -16px;
    border-top: 1px solid #323232;
  }

  .l-faq__item {
    cursor: pointer;
    list-style: none;
    display: list-item;
  }

  .l-faq__item-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    font-size: 16px;
    line-height: 1.1;
    color: #fff;
    border-bottom: 1px solid #323232;
  }

  .l-faq__item-title > span {
    padding-right: 10px;
    font-weight: 400;
  }

  .l-faq__item-title > .svg-accordion-chevron {
    width: 24px;
    height: 24px;
    transition: transform ease-out 0.2s;
    overflow: visible;
  }

  ._open .svg-accordion-chevron {
    transform: rotateZ(180deg);
  }

  .l-faq__item-content {
    display: none;
    padding: 14px 32px;
    line-height: 1.5;
    color: #fff;
    background-color: #2d2d2d;
  }

  .l-faq__item-content > ul {
    padding-left: 18px;
    list-style-type: disc;
  }

  .l-faq__item-content > ul > li + li {
    margin-top: 10px;
  }
  /* Accordion menu <<< */
`;
